export enum MenuRole {
  Vacancy = 'MENU_VACANCY',
  CompanyProfile = 'MENU_COMPANY_PROFILE',
  Wallet = 'MENU_WALLET',
  UserManagement = 'MENU_USER_MANAGEMENT',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  AccountSettings = 'MENU_USER_MANAGEMENT', // only users with UserManagement role can access settings
}

export const isMenuRole = (value: unknown): value is MenuRole =>
  Object.values(MenuRole).some((menuRole) => menuRole === value);
